import { NgModule } from '@angular/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { CommonModule } from '@nano/common';
import { AlertModule } from '@nano/common/alert';

import { FinanceModule } from '@nano/common/finance';
import { TfaModule } from '@nano/core/tfa';

import { CurrencyExchangeComponent } from './currency-exchange.component';
import { AccountSelectModule } from '@nano/account/account-select';

@NgModule({
  imports: [CommonModule, AlertModule, NzCollapseModule, AccountSelectModule, FinanceModule, TfaModule],
  declarations: [CurrencyExchangeComponent],
  exports: [CurrencyExchangeComponent]
})
export class CurrencyExchangeModule {}
